<div class="duna-documents-container" [class.event-context]="isInEventContext">
  <!-- Header -->
  <div class="documents-header">
    <h2>Dokumenter</h2>
    <div class="header-actions">
      <input
        type="file"
        #fileInput
        (change)="onFileInputChange($event)"
        multiple
        accept="image/*,video/*,audio/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,text/plain,text/csv,text/rtf,application/rtf,application/vnd.oasis.opendocument.text,application/vnd.oasis.opendocument.spreadsheet,application/vnd.oasis.opendocument.presentation"
        style="display: none"
      />
      @if (canUpload() && !isEventRootView()) {
      <button
        class="btn-primary"
        (click)="fileInput.click()"
        [disabled]="isLoading || !canUpload()"
      >
        <span class="material-icons">upload</span>
        Upload Filer
      </button>
      } @if (canUpload() && currentPath !== '/' && !isEventRootView()) {
      <button
        class="btn-secondary"
        (click)="showCreateFolder()"
        [disabled]="isLoading || !canUpload()"
      >
        <span class="material-icons">create_new_folder</span>
        Ny Mappe
      </button>
      }
      <button
        class="btn-secondary"
        (click)="loadFolder(currentPath)"
        [disabled]="isLoading"
      >
        <span class="material-icons">refresh</span>
        Opdater
      </button>
    </div>
  </div>

  <!-- Error message -->
  @if (errorMessage) {
  <div class="error-message">
    <span class="material-icons">error</span>
    {{ errorMessage }}
  </div>
  }

  <!-- Loading indicator -->
  @if (isLoading) {
  <div class="loading-overlay">
    <div class="spinner"></div>
    <p>Indlæser...</p>
  </div>
  }

  <!-- Upload Progress Bar is now rendered at body level via Renderer2 -->

  <!-- Virtual folder navigation -->
  @if (!isInEventContext && !isLocationScope()) {
  <div class="virtual-folders">
    @for (folder of virtualFolders; track folder) {
    <div
      class="virtual-folder-card"
      [class.disabled]="folder.disabled"
      [class.active]="currentPath.startsWith(folder.path)"
      (click)="changeFolder(folder.path)"
    >
      <span class="material-icons">{{ folder.icon }}</span>
      <span class="folder-name">{{ folder.name }}</span>
      @if (folder.disabled) {
      <div class="folder-info">
        <span class="info-text">{{ getFolderInfo(folder.name) }}</span>
      </div>
      }
    </div>
    }
  </div>
  }

  <!-- Event-specific file workspace -->
  @if (isEventScope() && isEventRootView()) {
  <div class="event-files-workspace">
    <div class="event-files-intro">
      <div class="event-files-intro-text">
        <h3>Begivenhedsfiler</h3>
        <p>
          Upload direkte til deltagere eller instruktører. Tilknyt eksisterende
          filer fra organisationen, hvis de allerede ligger der.
        </p>
      </div>
    </div>
    <div class="event-role-panels">
      @for (panel of eventRolePanels; track panel.role) {
      <section class="event-role-panel" [class]="panel.role">
        <header class="event-role-panel-header">
          <div class="event-role-panel-title">
            <span class="material-icons event-role-panel-icon">{{
              panel.icon
            }}</span>
            <div>
              <h4>{{ panel.title }}</h4>
              <p>{{ panel.subtitle }}</p>
            </div>
          </div>
          <div class="event-role-panel-actions">
            <button
              type="button"
              class="btn-primary"
              (click)="uploadForRole(panel.role)"
              [disabled]="isLoading"
            >
              <span class="material-icons">upload</span>
              Upload
            </button>
            <button
              type="button"
              class="btn-secondary"
              (click)="showShareFilesForRole(panel.role)"
              [disabled]="isLoading"
            >
              <span class="material-icons">link</span>
              Tilknyt fra organisation
            </button>
            <button
              type="button"
              class="btn-secondary"
              (click)="showCreateFolderForRole(panel.role)"
              [disabled]="isLoading"
            >
              <span class="material-icons">create_new_folder</span>
              Ny mappe
            </button>
          </div>
        </header>
        @if ( getEventRoleFolders(panel.role).length === 0 &&
        getEventRoleFiles(panel.role).length === 0 ) {
        <div class="event-role-empty">
          <span class="material-icons">folder_open</span>
          <p>Ingen filer her endnu. Upload eller tilknyt fra organisationen.</p>
        </div>
        } @else {
        <div class="event-role-items">
          @for (folder of getEventRoleFolders(panel.role); track
          folder.obfuscated_name) {
          <div
            class="event-role-item folder"
            [class.shared-file]="isSharedFolder(folder)"
            (click)="navigateToFolderFromRole(folder, panel.role)"
          >
            <span class="material-icons item-icon">{{
              isSharedFolder(folder) ? "link" : "folder"
            }}</span>
            <div class="item-body">
              <span class="item-name">{{ folder.display_name }}</span>
              <span class="item-meta">
                Mappe
                @if (isSharedFolder(folder)) {
                <span class="shared-chip">Forbundet</span>
                }
              </span>
            </div>
            @if (isSharedFolder(folder)) {
            <button
              class="btn-icon"
              (click)="removeFileAccess(folder); $event.stopPropagation()"
              title="Fjern fra begivenhed"
            >
              <span class="material-icons">remove_circle</span>
            </button>
            } @if (!isSharedFolder(folder)) {
            <button
              class="btn-icon"
              (click)="deleteFolder(folder); $event.stopPropagation()"
              title="Slet mappe"
            >
              <span class="material-icons">delete</span>
            </button>
            }
          </div>
          } @for (file of getEventRoleFiles(panel.role); track
          file.obfuscated_name) {
          <div
            class="event-role-item"
            [class.shared-file]="isSharedFile(file)"
            [class.file-not-ready]="!isFileReady(file)"
          >
            <span class="material-icons item-icon">{{
              file.is_video
                ? "videocam"
                : isSharedFile(file)
                ? "link"
                : "insert_drive_file"
            }}</span>
            <div class="item-body">
              <span class="item-name">{{
                file.display_name || file.original_name
              }}</span>
              <span class="item-meta">
                {{ formatFileSize(file.file_size) }}
                @if (isSharedFile(file)) {
                <span class="shared-chip">Forbundet</span>
                } @if (file.status && !isFileReady(file)) {
                <span class="status-chip">{{ getStatusLabel(file.status) }}</span>
                }
              </span>
            </div>
            <div class="item-actions">
              <button
                class="btn-icon"
                [disabled]="!isFileReady(file)"
                (click)="previewFile(file); $event.stopPropagation()"
                title="Forhåndsvisning"
              >
                <span class="material-icons">visibility</span>
              </button>
              <button
                class="btn-icon"
                [disabled]="!isFileReady(file)"
                (click)="
                  downloadFile(
                    file.obfuscated_name,
                    file.display_name || file.original_name || 'file'
                  );
                  $event.stopPropagation()
                "
                title="Download"
              >
                <span class="material-icons">download</span>
              </button>
              @if (isSharedFile(file)) {
              <button
                class="btn-icon"
                (click)="removeFileAccess(file); $event.stopPropagation()"
                title="Fjern fra begivenhed"
              >
                <span class="material-icons">remove_circle</span>
              </button>
              } @if (!isSharedFile(file) && canModifyFile(file)) {
              <button
                class="btn-icon"
                (click)="
                  deleteFile(file.obfuscated_name); $event.stopPropagation()
                "
                title="Slet"
              >
                <span class="material-icons">delete</span>
              </button>
              }
            </div>
          </div>
          }
        </div>
        }
      </section>
      }
    </div>
  </div>
  }

  <!-- Location-specific folder navigation -->
  @if (isLocationScope()) {
  <div class="location-folders">
    <div class="location-folder-header">
      <h3>Lokationsmapper</h3>
      <button
        class="btn-share-modern"
        (click)="showShareFiles()"
        [disabled]="isLoading"
      >
        <span class="material-icons">link</span>
        <span class="btn-text">Forbind filer</span>
        <span class="btn-subtitle">fra Organisation/Globalt</span>
      </button>
    </div>
    <div class="location-info">
      <span class="material-icons">location_on</span>
      <span>Alle filer i denne lokation er tilgængelige for alle brugere</span>
    </div>
  </div>
  }

  <!-- Current Path Breadcrumb -->
  @if (currentPath !== '/') {
  <div class="breadcrumb">
    <span class="material-icons">folder</span>
    <span>{{ getDisplayPath() }}</span>
    <button class="btn-back" (click)="goBack()">
      <span class="material-icons">arrow_back</span>
      Tilbage
    </button>
  </div>
  }

  <!-- Folders List -->
  @if (currentFolders.length > 0 && !isEventRootView()) {
  <div class="folder-list">
    <div class="folder-list-header">
      <span>Mapper</span>
    </div>
    @for (folder of currentFolders; track folder.obfuscated_name) {
    <div class="folder-list-item" (click)="navigateToFolder(folder)">
      <div class="folder-info" [class.shared-file]="isSharedFolder(folder)">
        <span
          class="material-icons"
          [class.shared-icon]="isSharedFolder(folder)"
        >
          {{ isSharedFolder(folder) ? "link" : "folder" }}
        </span>
        <span class="folder-name">{{ folder.display_name }}</span>
        <!-- Shared folder badge -->
        @if (isSharedFolder(folder)) {
        <span class="shared-badge">
          <span class="material-icons">link</span>
          <span>Forbundet</span>
        </span>
        }
      </div>
      <div class="folder-actions">
        <!-- For shared folders: Show remove access button -->
        @if (isSharedFolder(folder) && (isEventScope() || isLocationScope()) &&
        !(currentPath.startsWith('/Papirkurv') ||
        currentPath.startsWith('/Trash'))) {
        <button
          class="btn-icon"
          (click)="removeFileAccess(folder); $event.stopPropagation()"
          title="Fjern fra {{ isEventScope() ? 'begivenhed' : 'lokation' }}"
        >
          <span class="material-icons">remove_circle</span>
        </button>
        }
        <!-- For non-shared folders: Show rename and delete buttons -->
        @if (!isSharedFolder(folder)) {
        <!-- Show rename button for non-trash folders -->
        @if (canUpload() && !(currentPath.startsWith('/Papirkurv') ||
        currentPath.startsWith('/Trash'))) {
        <button
          class="btn-icon"
          (click)="renameFolder(folder); $event.stopPropagation()"
          title="Omdøb mappe"
        >
          <span class="material-icons">edit</span>
        </button>
        }
        <!-- Show restore button for trash folders -->
        @if (currentPath.startsWith('/Papirkurv') ||
        currentPath.startsWith('/Trash')) {
        <button
          class="btn-icon"
          (click)="restoreFolder(folder); $event.stopPropagation()"
          title="Gendan mappe"
        >
          <span class="material-icons">restore</span>
        </button>
        }
        <!-- Show delete button for non-trash folders -->
        @if (canUpload() && !(currentPath.startsWith('/Papirkurv') ||
        currentPath.startsWith('/Trash'))) {
        <button
          class="btn-icon"
          (click)="deleteFolder(folder); $event.stopPropagation()"
          title="Slet mappe"
        >
          <span class="material-icons">delete</span>
        </button>
        } }
      </div>
    </div>
    }
  </div>
  }

  @if (selectedFilesCount > 0 && !isEventRootView()) {
  <div class="bulk-selection-bar">
    <span class="bulk-selection-count">
      <span class="material-icons">check_circle</span>
      {{ selectedFilesCount }} valgt
    </span>
    <div class="bulk-selection-actions">
      @if (canBulkMove()) {
      <button
        type="button"
        class="btn-secondary"
        (click)="showMoveForSelectedFiles()"
        [disabled]="isLoading"
      >
        <span class="material-icons">drive_file_move</span>
        Flyt til mappe
      </button>
      }
      @if (canBulkDelete()) {
      <button
        type="button"
        class="btn-danger"
        (click)="openDeleteConfirmationForSelection()"
        [disabled]="isLoading"
      >
        <span class="material-icons">delete</span>
        Slet valgte
      </button>
      }
      <button
        type="button"
        class="btn-secondary btn-ghost"
        (click)="clearFileSelection()"
      >
        Ryd valg
      </button>
    </div>
  </div>
  }

  <!-- File List -->
  @if (currentFiles.length > 0 && !isEventRootView()) {
  <div class="file-list">
    <div class="file-list-header">
      <span class="file-list-select-col">
        @if (selectableFiles.length > 0) {
        <input
          type="checkbox"
          class="file-select-checkbox"
          [checked]="allSelectableFilesSelected"
          (click)="toggleSelectAllFiles($event)"
          title="Vælg alle filer du kan slette/flytte"
        />
        }
      </span>
      <span>Filer</span>
      <span>Størrelse</span>
      <span>Dato</span>
      <span>Handlinger</span>
    </div>
    @for (file of currentFiles; track file.obfuscated_name) {
    <div
      class="file-list-item"
      [class.file-not-ready]="!isFileReady(file)"
      [class.file-list-item-selected]="isFileSelected(file)"
      (dblclick)="isFileReady(file) && previewFile(file)"
    >
      <span class="file-list-select-col" (click)="$event.stopPropagation()">
        @if (isFileSelectable(file)) {
        <input
          type="checkbox"
          class="file-select-checkbox"
          [checked]="isFileSelected(file)"
          (change)="toggleFileSelection(file, $event)"
          [attr.aria-label]="
            'Vælg ' + (file.display_name || file.original_name)
          "
        />
        }
      </span>
      <div class="file-info" [class.shared-file]="isSharedFile(file)">
        <!-- Different icons for shared vs owned files -->
        <span
          class="material-icons file-icon"
          [class.shared-icon]="isSharedFile(file)"
        >
          @if (!isSharedFile(file)) {
          <span>{{ file.is_video ? "videocam" : "insert_drive_file" }}</span>
          } @if (isSharedFile(file)) {
          <span>{{ file.is_video ? "videocam" : "link" }}</span>
          }
        </span>
        <span class="file-name">{{
          file.display_name || file.original_name
        }}</span>
        <!-- Upload status badge -->
        @if (file.status && !isFileReady(file)) {
        <span
          class="status-badge"
          [class]="getStatusBadgeClass(file.status)"
          [title]="'Status: ' + getStatusLabel(file.status)"
        >
          @if (file.status === 'uploading' || file.status === 'processing') {
          <span class="material-icons status-icon">sync</span>
          } @if (file.status === 'queued') {
          <span class="material-icons status-icon">schedule</span>
          } @if (file.status === 'initializing') {
          <span class="material-icons status-icon">hourglass_empty</span>
          } @if (file.status === 'failed') {
          <span class="material-icons status-icon">error</span>
          }
          <span class="status-text">{{ getStatusLabel(file.status) }}</span>
        </span>
        }
        <!-- File origin indicator for shared files -->
        @if (isSharedFile(file)) {
        <span class="file-origin">
          <span class="material-icons origin-icon">{{
            getFileOriginIcon(file)
          }}</span>
          <span class="origin-label">{{ getFileOriginLabel(file) }}</span>
        </span>
        }
        <!-- Shared file badge -->
        @if (isSharedFile(file)) {
        <span class="shared-badge">
          <span class="material-icons">link</span>
          <span>Forbundet</span>
        </span>
        }
      </div>
      <span class="file-size">{{ formatFileSize(file.file_size) }}</span>
      <span class="file-date">{{
        formatDate(file.updated_at || file.created_at || "")
      }}</span>
      <div class="file-actions">
        <!-- Preview and download buttons - disabled if file is not ready -->
        <button
          class="btn-icon preview-btn"
          [class.disabled]="!isFileReady(file)"
          [disabled]="!isFileReady(file)"
          (click)="previewFile(file); $event.stopPropagation()"
          [title]="
            isFileReady(file)
              ? 'Forhåndsvisning'
              : 'Filen er ikke klar til visning'
          "
        >
          <span class="material-icons">visibility</span>
        </button>
        <button
          class="btn-icon"
          [class.disabled]="!isFileReady(file)"
          [disabled]="!isFileReady(file)"
          (click)="
            downloadFile(
              file.obfuscated_name,
              file.display_name || file.original_name || 'file'
            );
            $event.stopPropagation()
          "
          [title]="
            isFileReady(file) ? 'Download' : 'Filen er ikke klar til download'
          "
        >
          <span class="material-icons">download</span>
        </button>
        <!-- For readonly files (shared files): Show info and remove access buttons -->
        @if (isSharedFile(file)) { @if (!(currentPath.startsWith('/Papirkurv')
        || currentPath.startsWith('/Trash'))) {
        <button
          class="btn-icon"
          (click)="showFileInfo(file); $event.stopPropagation()"
          title="Information"
        >
          <span class="material-icons">info</span>
        </button>
        } @if ((isEventScope() || isLocationScope())) {
        <button
          class="btn-icon"
          (click)="removeFileAccess(file); $event.stopPropagation()"
          title="Fjern fra {{ isEventScope() ? 'begivenhed' : 'lokation' }}"
        >
          <span class="material-icons">remove_circle</span>
        </button>
        } }
        <!-- For editable files: Show full set of actions -->
        @if (!isSharedFile(file)) { @if (!(currentPath.startsWith('/Papirkurv')
        || currentPath.startsWith('/Trash'))) {
        <button
          class="btn-icon"
          (click)="showFileInfo(file); $event.stopPropagation()"
          title="Information"
        >
          <span class="material-icons">info</span>
        </button>
        } @if (canModifyFile(file) && !(currentPath.startsWith('/Papirkurv') ||
        currentPath.startsWith('/Trash')) && canUpload()) {
        <button
          class="btn-icon"
          (click)="showMoveFile(file); $event.stopPropagation()"
          title="Flyt til mappe"
        >
          <span class="material-icons">drive_file_move</span>
        </button>
        } @if (canModifyFile(file) && !(currentPath.startsWith('/Papirkurv') ||
        currentPath.startsWith('/Trash')) && (currentPath.startsWith('/Globalt')
        ? isSuperadmin() : true)) {
        <button
          class="btn-icon"
          (click)="deleteFile(file.obfuscated_name); $event.stopPropagation()"
          title="Slet"
        >
          <span class="material-icons">delete</span>
        </button>
        } }
        <!-- Trash-specific buttons -->
        @if (currentPath.startsWith('/Papirkurv') ||
        currentPath.startsWith('/Trash')) {
        <button
          class="btn-icon"
          (click)="
            restoreFromTrash(file.obfuscated_name); $event.stopPropagation()
          "
          title="Gendan"
        >
          <span class="material-icons">restore</span>
        </button>
        }
      </div>
    </div>
    }
  </div>
  }

  <!-- Empty State -->
  @if ( !isEventRootView() && currentFiles.length === 0 && currentFolders.length
  === 0 && currentPath !== '/' ) {
  <div class="empty-state">
    <span class="material-icons">folder_open</span>
    <p>Ingen filer eller mapper i denne mappe</p>
    <div class="empty-state-actions">
      @if (canUpload()) {
      <button class="btn-primary" (click)="fileInput.click()">
        <span class="material-icons">upload</span>
        Upload din første fil
      </button>
      } @if (canUpload()) {
      <button class="btn-secondary" (click)="showCreateFolder()">
        <span class="material-icons">create_new_folder</span>
        Opret ny mappe
      </button>
      }
    </div>
    @if (!canUpload()) {
    <div class="upload-disabled-info">
      <span class="material-icons">block</span>
      <p>Upload ikke tilgængelig i denne mappe</p>
    </div>
    }
  </div>
  }

  <!-- Help section -->
  <div class="help-section" [class.expanded]="helpExpanded">
    <div class="help-header" (click)="toggleHelp()">
      <h3>
        <span class="material-icons">help_outline</span>
        Hjælp & Info
      </h3>
      <span class="help-toggle-icon material-icons">{{
        helpExpanded ? "expand_less" : "expand_more"
      }}</span>
    </div>

    @if (helpExpanded) {
    <div class="help-content">
      <div class="help-grid">
        <div class="help-card">
          <div class="help-card-header">
            <span class="material-icons">folder</span>
            <h4>Mapper</h4>
          </div>
          <ul>
            <li>
              <strong>Begivenheder:</strong> Gå direkte til begivenheden for at
              uploade filer
            </li>
            <li>
              <strong>Lokationer:</strong> Gå direkte til lokationen for at
              uploade filer
            </li>
            <li>
              <strong>Organisation:</strong> Filer knyttet til organisationen
            </li>
            <li>
              <strong>Globalt:</strong> @if (isSuperadmin()) {
              <span> Filer tilgængelige for alle</span>
              }@if (!isSuperadmin()) {
              <span> Kun DUNA Admins kan administrere denne mappe</span>
              }
            </li>
            <li>
              <strong>Papirkurv:</strong> Slettede filer (slettes efter 30 dage)
              - ikke tilgængeligt for upload
            </li>
          </ul>
        </div>
        <div class="help-card">
          <div class="help-card-header">
            <span class="material-icons">settings</span>
            <h4>Operationer</h4>
          </div>
          <ul>
            <li>
              <strong>Upload:</strong> Vælg mappe og klik på upload-knappen
            </li>
            <li><strong>Download:</strong> Klik på download-ikon</li>
            <li>
              <strong>Flere filer:</strong> Markér med afkrydsningsfelter — flyt
              eller slet flere ad gangen
            </li>
            <li>
              <strong>Slet:</strong> Kræver bekræftelse (skriv SLET) — filer
              flyttes til papirkurv
            </li>
            <li><strong>Visning:</strong> Klik på fil for forhåndsvisning</li>
          </ul>
        </div>
        <div class="help-card">
          <div class="help-card-header">
            <span class="material-icons">storage</span>
            <h4>Teknisk</h4>
          </div>
          <ul>
            <li>
              <strong>Billeder:</strong> JPEG, PNG, GIF, WebP, SVG, BMP, TIFF
              (maks. 1 GB)
            </li>
            <li>
              <strong>Videoer:</strong> MP4, AVI, MOV, WMV, FLV, WebM, MKV
              (maks. 10 GB)
            </li>
            <li>
              <strong>Lyd:</strong> MP3, WAV, OGG, AAC, FLAC, M4A (maks. 500 MB)
            </li>
            <li>
              <strong>Dokumenter:</strong> PDF, Word (.doc/.docx), Excel
              (.xls/.xlsx), PowerPoint (.ppt/.pptx), TXT, CSV, RTF (maks. 1 GB)
            </li>
            <li><strong>OpenDocument:</strong> ODT, ODS, ODP (maks. 1 GB)</li>
            <li>Alle filer krypteres automatisk</li>
            <li>Videoer optimeres for streaming</li>
          </ul>
        </div>
        <div class="help-card">
          <div class="help-card-header">
            <span class="material-icons">schedule</span>
            <h4>Bevaringspolitik</h4>
          </div>
          <ul>
            <li>Slettede filer bevares i <strong>30 dage</strong></li>
            <li>Gendannelse mulig inden for fristen</li>
            <li>Efter 30 dage slettes filer permanent</li>
          </ul>
        </div>
      </div>
    </div>
    }
  </div>

  <!-- Create Folder Dialog -->
  @if (showCreateFolderDialog) {
  <div class="dialog-overlay" (click)="hideCreateFolder()">
    <div class="dialog-content" (click)="$event.stopPropagation()">
      <div class="dialog-header">
        <h3>Opret ny mappe</h3>
        <button class="btn-icon" (click)="hideCreateFolder()">
          <span class="material-icons">close</span>
        </button>
      </div>
      <div class="dialog-body">
        <div class="form-group">
          <label for="folderName">Mappe navn:</label>
          <input
            type="text"
            id="folderName"
            [(ngModel)]="newFolderName"
            (ngModelChange)="validateFolderNameInput()"
            placeholder="Indtast mappe navn"
            maxlength="100"
            (keyup.enter)="!isCreatingFolder && createFolder()"
            (keyup.escape)="hideCreateFolder()"
            [class.error]="folderNameInvalidChars.length > 0"
            autofocus
          />
          @if (folderNameInvalidChars.length > 0) {
          <div class="error-message">
            <span class="material-icons">error_outline</span>
            <span>
              Mappe navn kan kun indeholde bogstaver (inkl. Æ, Ø, Å), tal,
              mellemrum, bindestreger og understregninger
            </span>
          </div>
          }
        </div>
      </div>
      <div class="dialog-footer">
        <button class="btn-secondary" (click)="hideCreateFolder()">
          Annuller
        </button>
        <button
          class="btn-primary"
          (click)="createFolder()"
          [disabled]="
            isCreatingFolder ||
            !newFolderName.trim() ||
            folderNameInvalidChars.length > 0
          "
        >
          @if (isCreatingFolder) {
          <span class="material-icons">hourglass_empty</span>
          } @if (!isCreatingFolder) {
          <span class="material-icons">create_new_folder</span>
          }
          {{ isCreatingFolder ? "Opretter..." : "Opret mappe" }}
        </button>
      </div>
    </div>
  </div>
  }

  <!-- File Information Dialog -->
  @if (showFileInfoDialog) {
  <div class="dialog-overlay" (click)="hideFileInfo()">
    <div
      class="dialog-content file-info-dialog"
      (click)="$event.stopPropagation()"
    >
      <div class="dialog-header">
        <h3>Fil Information</h3>
        <button class="btn-icon" (click)="hideFileInfo()">
          <span class="material-icons">close</span>
        </button>
      </div>
      @if (selectedFileInfo) {
      <div class="dialog-body">
        <div class="file-info-grid">
          <div class="info-row">
            <label>Filnavn:</label>
            <span>{{
              selectedFileInfo.display_name || selectedFileInfo.original_name
            }}</span>
          </div>
          <div class="info-row">
            <label>Original navn:</label>
            <span>{{ selectedFileInfo.original_name }}</span>
          </div>
          <div class="info-row">
            <label>Størrelse:</label>
            <span>{{ formatFileSize(selectedFileInfo.file_size) }}</span>
          </div>
          <div class="info-row">
            <label>Type:</label>
            <span>{{ selectedFileInfo.mime_type || "Ukendt" }}</span>
          </div>
          <div class="info-row">
            <label>Opretet:</label>
            <span>{{ formatDate(selectedFileInfo.created_at || "") }}</span>
          </div>
          <div class="info-row">
            <label>Opdateret:</label>
            <span>{{ formatDate(selectedFileInfo.updated_at || "") }}</span>
          </div>
          <div class="info-row edit-name">
            <label>Visningsnavn:</label>
            <div class="edit-container">
              @if (editingDisplayName) {
              <input
                type="text"
                [(ngModel)]="selectedFileInfo.display_name"
                placeholder="Indtast visningsnavn"
                maxlength="100"
                (keyup.enter)="saveDisplayName()"
                (keyup.escape)="cancelEditingDisplayName()"
                autofocus
              />
              } @if (!editingDisplayName) {
              <span>{{
                selectedFileInfo.display_name || selectedFileInfo.original_name
              }}</span>
              } @if (!editingDisplayName) {
              <button
                class="btn-icon-small"
                (click)="startEditingDisplayName()"
                title="Rediger navn"
              >
                <span class="material-icons">edit</span>
              </button>
              } @if (editingDisplayName) {
              <button
                class="btn-icon-small"
                (click)="saveDisplayName()"
                title="Gem"
              >
                <span class="material-icons">save</span>
              </button>
              } @if (editingDisplayName) {
              <button
                class="btn-icon-small"
                (click)="cancelEditingDisplayName()"
                title="Annuller"
              >
                <span class="material-icons">close</span>
              </button>
              }
            </div>
          </div>
          @if (selectedFileInfo.is_video) {
          <div class="info-row">
            <label>Video:</label>
            <span>Ja</span>
          </div>
          } @if (selectedFileInfo.status) {
          <div class="info-row">
            <label>Status:</label>
            <span>{{ selectedFileInfo.status }}</span>
          </div>
          }
        </div>
      </div>
      }
      <div class="dialog-footer">
        <button class="btn-secondary" (click)="hideFileInfo()">Luk</button>
      </div>
    </div>
  </div>
  }

  <!-- Delete files confirmation -->
  @if (showDeleteFilesDialog) {
  <div class="dialog-overlay delete-files-overlay" (click)="hideDeleteFilesDialog()">
    <div
      class="dialog-content delete-files-dialog"
      (click)="$event.stopPropagation()"
    >
      <div class="dialog-header delete-dialog-header">
        <h3>
          <span class="material-icons">warning</span>
          Slet filer permanent?
        </h3>
        <button class="btn-icon" (click)="hideDeleteFilesDialog()" type="button">
          <span class="material-icons">close</span>
        </button>
      </div>
      <div class="dialog-body">
        <div class="delete-warning-banner">
          <p>
            <strong>Advarsel:</strong> Du er ved at flytte
            {{ filesPendingDelete.length === 1 ? '1 fil' : filesPendingDelete.length + ' filer' }}
            til papirkurven. Filer i papirkurven kan gendannes inden de automatisk
            slettes efter ca. 30 dage — derefter er de væk.
          </p>
          <p>Dette kan påvirke deltagere, instruktører og tilknyttede begivenheder.</p>
        </div>
        <ul class="delete-file-list">
          @for (file of filesPendingDelete; track file.obfuscated_name) {
          <li>
            {{ file.display_name || file.original_name }}
            <span class="delete-file-meta">{{
              formatFileSize(file.file_size)
            }}</span>
          </li>
          }
        </ul>
        <label class="delete-confirm-label">
          Skriv <strong>{{ deleteConfirmWord }}</strong> for at bekræfte:
        </label>
        <input
          type="text"
          class="delete-confirm-input"
          [(ngModel)]="deleteConfirmPhrase"
          [placeholder]="deleteConfirmWord"
          autocomplete="off"
          (keyup.enter)="deleteConfirmationValid && confirmDeleteFiles()"
        />
      </div>
      <div class="dialog-footer">
        <button
          type="button"
          class="btn-secondary"
          (click)="hideDeleteFilesDialog()"
        >
          Annuller
        </button>
        <button
          type="button"
          class="btn-danger"
          [disabled]="!deleteConfirmationValid || isLoading"
          (click)="confirmDeleteFiles()"
        >
          Slet {{ filesPendingDelete.length === 1 ? 'fil' : 'filer' }}
        </button>
      </div>
    </div>
  </div>
  }

  <!-- Move File Dialog -->
  @if (showMoveFileDialog) {
  <div class="dialog-overlay" (click)="hideMoveFile()">
    <div
      class="dialog-content move-file-dialog"
      (click)="$event.stopPropagation()"
    >
      <div class="dialog-header">
        <h3>
          {{
            filesToMove.length === 1
              ? 'Flyt fil til mappe'
              : 'Flyt ' + filesToMove.length + ' filer til mappe'
          }}
        </h3>
        <button class="btn-icon" (click)="hideMoveFile()">
          <span class="material-icons">close</span>
        </button>
      </div>
      @if (filesToMove.length > 0) {
      <div class="dialog-body">
        <div class="move-info">
          @if (filesToMove.length === 1) {
          <p>
            Vil du flytte
            <strong>{{
              filesToMove[0].display_name || filesToMove[0].original_name
            }}</strong>
            til en anden mappe?
          </p>
          } @else {
          <p>Vælg mappe for {{ filesToMove.length }} filer:</p>
          <ul class="move-files-preview">
            @for (file of filesToMove; track file.obfuscated_name) {
            <li>{{ file.display_name || file.original_name }}</li>
            }
          </ul>
          }
        </div>
        <div class="folder-list">
          @for (folder of availableFolders; track folder) {
          <div class="folder-option" (click)="moveFileToFolder(folder)">
            <span class="material-icons">folder</span>
            <span>{{ folder.display_name }}</span>
          </div>
          }
          <!-- Option to move to root folder -->
          <div class="folder-option root-folder" (click)="moveToRootFolder()">
            <span class="material-icons">home</span>
            <span>Root mappe</span>
          </div>
        </div>
        @if (availableFolders.length === 0) {
        <div class="no-folders">
          <span class="material-icons">folder_open</span>
          <p>Ingen mapper tilgængelige</p>
        </div>
        }
      </div>
      }
      <div class="dialog-footer">
        <button class="btn-secondary" (click)="hideMoveFile()">Annuller</button>
      </div>
    </div>
  </div>
  }

  <!-- Share Files Dialog -->
  @if (showShareFileDialog) {
  <div class="dialog-overlay" (click)="hideShareFiles()">
    <div
      class="dialog-content share-files-dialog"
      (click)="$event.stopPropagation()"
    >
      <div class="dialog-header">
        <div class="share-dialog-heading">
          <h3>Tilknyt fra organisationen</h3>
          @if (isEventScope()) {
          <span
            class="share-role-badge"
            [class.instructor]="shareTargetRole === 'instructor'"
          >
            <span class="material-icons">{{
              shareTargetRole === "instructor" ? "school" : "people"
            }}</span>
            Synlig for {{ shareTargetRoleLabel }}
          </span>
          }
        </div>
        <button class="btn-icon" (click)="hideShareFiles()" aria-label="Luk">
          <span class="material-icons">close</span>
        </button>
      </div>
      <div class="dialog-body share-dialog-body">
        <div class="share-toolbar">
          <div class="share-search">
            <span class="material-icons">search</span>
            <input
              type="text"
              placeholder="Søg i mapper og filer..."
              [(ngModel)]="fileSearchQuery"
              (input)="filterFiles()"
            />
            @if (fileSearchQuery) {
            <button
              type="button"
              class="btn-icon"
              (click)="fileSearchQuery = ''; filterFiles()"
              aria-label="Ryd søgning"
            >
              <span class="material-icons">close</span>
            </button>
            }
          </div>
          @if (isShareBrowsingRoot) {
          <div class="share-source-tabs">
            <button
              type="button"
              class="share-source-tab"
              [class.active]="selectedFileCategory === 'all'"
              (click)="setShareCategory('all')"
            >
              Alle
            </button>
            <button
              type="button"
              class="share-source-tab"
              [class.active]="selectedFileCategory === 'organization'"
              (click)="setShareCategory('organization')"
            >
              <span class="material-icons">business</span>
              Organisation
            </button>
            <button
              type="button"
              class="share-source-tab"
              [class.active]="selectedFileCategory === 'global'"
              (click)="setShareCategory('global')"
            >
              <span class="material-icons">public</span>
              Globalt
            </button>
          </div>
          }
        </div>

        <nav class="share-breadcrumb" aria-label="Mappe sti">
          <button type="button" (click)="goToShareBrowseRoot()">
            <span class="material-icons">home</span>
            Bibliotek
          </button>
          @for (crumb of shareBrowsePath; track crumb.obfuscatedName; let i =
          $index) {
          <span class="material-icons crumb-sep">chevron_right</span>
          <button type="button" (click)="goToShareBrowseIndex(i)">
            {{ crumb.name }}
          </button>
          }
        </nav>

        @if (isEventScope() && !shareRoleLocked) {
        <div class="role-selection">
          <h4>Hvem skal kunne se filen?</h4>
          <div class="role-options">
            <label [class.selected]="shareTargetRole === 'participant'">
              <input
                type="radio"
                [(ngModel)]="shareTargetRole"
                value="participant"
              />
              <span class="material-icons">people</span>
              <span>Deltagere</span>
            </label>
            <label [class.selected]="shareTargetRole === 'instructor'">
              <input
                type="radio"
                [(ngModel)]="shareTargetRole"
                value="instructor"
              />
              <span class="material-icons">school</span>
              <span>Instruktører</span>
            </label>
          </div>
        </div>
        }

        <div class="share-file-browser">
          @if (shareIsBrowsing) {
          <div class="share-browser-status">
            <div class="spinner"></div>
            <span>Indlæser mapper...</span>
          </div>
          } @else if (shareBrowseFolders.length === 0 &&
          shareBrowseFileItems.length === 0) {
          <div class="share-browser-status">
            <span class="material-icons">folder_open</span>
            <p>
              @if (fileSearchQuery) { Ingen filer matcher søgningen. } @else {
              Der er ingen filer i denne mappe. }
            </p>
          </div>
          } @else {
          <div class="share-item-list">
            @if (shareBrowseFolders.length > 0) {
            <div class="share-item-group-label">Mapper</div>
            @for (folder of shareBrowseFolders; track folder.obfuscated_name) {
            <div
              class="share-item folder"
              [class.selected]="fileToShare === folder"
            >
              <button
                type="button"
                class="share-item-main"
                (click)="openShareBrowseFolder(folder, $event)"
              >
                <span class="share-item-icon folder">
                  <span class="material-icons">folder</span>
                </span>
                <span class="share-item-text">
                  <span class="share-item-name">{{
                    folder.display_name || folder.original_name
                  }}</span>
                  <span class="share-item-meta">
                    Mappe
                    @if (isShareBrowsingRoot) {
                    <span>· {{ getShareOriginLabel(folder) }}</span>
                    }
                  </span>
                </span>
                <span class="material-icons share-item-chevron"
                  >chevron_right</span
                >
              </button>
              <button
                type="button"
                class="share-item-attach"
                (click)="selectFileToShare(folder); $event.stopPropagation()"
                [class.active]="fileToShare === folder"
              >
                {{ fileToShare === folder ? "Valgt" : "Tilknyt mappe" }}
              </button>
            </div>
            }
            } @if (shareBrowseFileItems.length > 0) {
            <div class="share-item-group-label">Filer</div>
            @for (file of shareBrowseFileItems; track file.obfuscated_name) {
            <button
              type="button"
              class="share-item file"
              [class.selected]="fileToShare === file"
              (click)="selectFileToShare(file)"
            >
              <span class="share-item-icon">
                <span class="material-icons">{{ getShareItemIcon(file) }}</span>
              </span>
              <span class="share-item-text">
                <span class="share-item-name">{{
                  file.display_name || file.original_name
                }}</span>
                <span class="share-item-meta">
                  {{ formatFileSize(file.file_size) }}
                  ·
                  {{ formatDate(file.updated_at || file.created_at || "") }}
                  @if (isShareBrowsingRoot) {
                  <span>· {{ getShareOriginLabel(file) }}</span>
                  }
                </span>
              </span>
              @if (fileToShare === file) {
              <span class="material-icons share-item-check">check_circle</span>
              }
            </button>
            }
            }
          </div>
          }
        </div>
      </div>
      <div class="dialog-footer">
        <div class="share-footer-selection">
          @if (fileToShare) {
          <span class="material-icons">{{
            getShareItemIcon(fileToShare)
          }}</span>
          <span>{{
            fileToShare.display_name || fileToShare.original_name
          }}</span>
          } @else {
          <span class="share-footer-hint"
            >Vælg en fil, eller tilknyt en hel mappe</span
          >
          }
        </div>
        <div class="share-footer-actions">
          <button class="btn-secondary" (click)="hideShareFiles()">
            Annuller
          </button>
          <button
            class="btn-primary"
            (click)="shareFileToCurrentScope()"
            [disabled]="!fileToShare || shareIsBrowsing"
          >
            <span class="material-icons">link</span>
            Tilknyt
          </button>
        </div>
      </div>
    </div>
  </div>
  }
</div>
